<template>
  <div
    class="image-container py-9 text-center text-white"
    :aria-label="$tt('page.features.open_passports_img')"
  >
    <AppContainer class="inner-container">
      <h2>
        <slot />
      </h2>
    </AppContainer>
  </div>
</template>

<style lang="scss" scoped>
.image-container {
  position: relative;
  background-size: cover;
  background-position: bottom;
  background-image: url('/images/passports-closeup.jpg');
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #021FAB;
    opacity: 0.75;
    z-index: 1;
  }
  .inner-container {
    position: relative;
    z-index: 2;
    max-width: 960px;
    margin: auto;
  }
}
h2 {
  color: #fff;
}

@media (max-width: 850px) {
  .image-container {
    padding-top: var(--space-8) !important;
    padding-bottom: var(--space-8) !important;
    background-position: top;
    .inner-container {
      max-width: 100%;
    }
  }
}
</style>